import { StyledFlex, useViewport } from '@tryhackme/thm-ui-components';
import type { AzureLab } from 'src/common/interfaces';
import { StyledMachineContent, StyledSectionTitle } from 'src/features/room/components/active-machine-info/active-machine-info.styles';
import { StyledSectionHeader } from 'src/features/room/components/tasks/components/azure-cloud-details/azure-cloud-details-modal.styles';
import { AzureCredentials } from 'src/features/room/components/tasks/components/azure-cloud-details/components/azure-credentials';
import { AzureEnvironment } from 'src/features/room/components/tasks/components/azure-cloud-details/components/azure-environment';
import { AzureTabs } from 'src/features/room/components/tasks/components/azure-cloud-details/components/azure-tabs';
import { LabActions } from 'src/features/room/components/tasks/components/azure-cloud-details/components/lab-actions';
import { useLabExpiryCountdown } from 'src/features/room/components/tasks/components/azure-cloud-details/hooks/expires-in-countdown';
export const ActiveLabInfo = ({
  lab
}: {
  lab: AzureLab;
}) => {
  const {
    width
  } = useViewport();
  const {
    formattedExpiry
  } = useLabExpiryCountdown(lab?.expires && new Date(lab?.expires));
  return <>
      <StyledSectionTitle data-sentry-element="StyledSectionTitle" data-sentry-source-file="active-lab-info.tsx">
        <p>Active Lab Information&nbsp;-&nbsp;{lab.lab}</p>
      </StyledSectionTitle>
      <StyledMachineContent id="active-lab-info" $vmPanelOpen={false} data-testid="active-lab-info" data-sentry-element="StyledMachineContent" data-sentry-source-file="active-lab-info.tsx">
        {width > 1024 ? <StyledFlex flexDirection="row" justifyContent="space-between" alignItems="flex-start">
            <div>
              <StyledSectionHeader>Environment</StyledSectionHeader>
              <AzureEnvironment lab={lab} formattedExpiry={formattedExpiry} />
            </div>
            {lab?.actions && lab?.actions.length > 0 && <div>
                <StyledSectionHeader>Actions</StyledSectionHeader>
                <LabActions actions={lab?.actions} labId={lab._id} taskId={lab.taskId} roomId={lab.roomId} disableActions={formattedExpiry === null} />
              </div>}
            <div>
              <StyledSectionHeader>Credentials</StyledSectionHeader>
              <AzureCredentials lab={lab} formattedExpiry={formattedExpiry} />
            </div>
          </StyledFlex> : <AzureTabs lab={lab} formattedExpiry={formattedExpiry} />}
      </StyledMachineContent>
    </>;
};